import React from 'react';
import { AnalysisEntitlement } from '../../../services/subscriptionService';
import './UpsellPanel.css';

const TIER_ROWS = [
  { tier: 'Starter', categories: 'Sales · Occupancy' },
  { tier: 'Professional', categories: '+ Product · Payments · Cancellations · Anomalies' },
  { tier: 'Enterprise', categories: '+ Members · Forecasting · CSV export' },
];

/**
 * Rendered by SubscriptionGate for the locked states: no subscription,
 * expired past grace, or cancelled.
 */
const UpsellPanel: React.FC<{ entitlement: AnalysisEntitlement }> = ({ entitlement }) => {
  const heading =
    entitlement.status === 'expired'
      ? 'Your Analysis subscription has expired'
      : entitlement.status === 'cancelled'
        ? 'Your Analysis subscription was cancelled'
        : 'Unlock Business Analytics for your campground';

  const message =
    entitlement.status === 'expired' || entitlement.status === 'cancelled'
      ? 'Contact your HCP representative to renew and pick up right where you left off.'
      : 'See sales trends, occupancy, payment health, and booking anomalies — built for campground operations.';

  return (
    <div className="upsell-panel">
      <span className="upsell-panel-icon">📊</span>
      <h2 className="upsell-panel-heading">{heading}</h2>
      <p className="upsell-panel-message">{message}</p>

      <div className="upsell-panel-tiers">
        {TIER_ROWS.map(row => (
          <div key={row.tier} className="upsell-panel-tier">
            <span className="upsell-panel-tier-name">{row.tier}</span>
            <span className="upsell-panel-tier-categories">{row.categories}</span>
          </div>
        ))}
      </div>

      <p className="upsell-panel-contact">
        Contact your HCP representative to {entitlement.status === 'none' ? 'start a 14-day free trial' : 'renew your subscription'}.
      </p>
    </div>
  );
};

export default UpsellPanel;
